var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-flex-centered"},[_c('v-img',{attrs:{"width":"200","src":require("@/assets/logo-bg-black.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }